import React, { Component } from 'react';
import { Button, Form, InputGroup, FormText, FormControl } from 'react-bootstrap';
import { withRouter, Redirect } from 'react-router-dom';
import {browserHistory} from 'react-router'
import apiFetch from "../utils/apiFetch";

class AlbumEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            photographer_contact: '',
            priority: "0",
            need_redirect_to_dashboard: false,
            current_allbum: null,
            album_link: '',
            albumId: 0,
            likes: 0,
            dislikes: 0,
            all_shows: 0,
            album_in_top: 0,
            album_in_other: 0,
            album_in_winners: 0,
            new_album_link: "",
            photographer_vk_link: ""
        }
    }

    componentDidMount() {
        const { albumId } = this.props.match.params;
        console.log(albumId);
        this.setState({albumId: albumId});
        console.log(this.state.albumId);
        this.loadAlbums();
    }

    loadAlbumStats = () => {
        apiFetch('stats.byAlbumId', {
            album_id: this.state.albumId
        }).then((result) => {
            console.log(result);
            if (!result.success) {

            } else {
                this.setState(result.stats);
            }
        })
    }

    loadAlbums = () => {
        apiFetch('albums.get', {
            login: localStorage.getItem('login'),
            password: localStorage.getItem('password')
        }).then((result) => {
            console.log(result);
            if (!result.success) {
                this.setState({need_login: true});
                window.location.replace("/auth");
            } else {
                result.items.forEach((album) => {
                    if (album.id == this.state.albumId) {
                        this.setState(album);
                        this.loadAlbumStats();
                    }
                })
            }
        })
    }

    onChangePhotographerContact = (e) => {
        this.setState({photographer_contact: event.target.value});
    }

    onChangeNewAlbumLink = (e) => {
        this.setState({new_album_link: event.target.value});
    }

    onChangePriority = (e) => {
        this.setState({priority: event.target.value});
    }

    onChangePhotographerVkLink = (e) => {
        this.setState({photographer_vk_link: event.target.value});
    }


    editAlbum = () => {
        apiFetch('albums.edit', {
            album_id: this.state.albumId,
            contact: this.state.photographer_contact,
            priority: this.state.priority,
            new_album_link: this.state.new_album_link,
            photographer_vk_link: this.state.photographer_vk_link
        }).then((result) => {
            this.setState({need_redirect_to_dashboard: true})
        });
    }

    resetStats = () => {
        if(confirm('Вы действительно хотите обнулить статистику альбома?')) {
            apiFetch('stats.resetByAlbum', {
                album_id: this.state.albumId
            }).then((result) => {
                location.reload();
            });
        }
    }

    render() {
        return (
            <div className="col-md-5">
                {this.state.need_redirect_to_dashboard && <Redirect to="/dashboard" />}
                <Form>
                    <h3>Редактировать альбом</h3>
                    <Form.Group>
                        <Form.Label>Ссылка на альбом</Form.Label><br/>
                        <a href={this.state.album_link}>{this.state.album_link}</a>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Статистика</Form.Label><br/>
                        <b>Всего показано фотографий из альбома - {this.state.all_shows}</b><br/>
                        <b>Из них лайки - {this.state.likes}</b> <br/>
                        <b>Дизлайки - {this.state.dislikes}</b> <br/>

                        <b>Количество показов информации про фотографа - {this.state.album_in_winners}</b> <br/>
                        <Button onClick={this.resetStats}>Обнулить статистику по альбому</Button>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Контакт фотографа</Form.Label>
                        <Form.Control as="textarea" name="photographer_contact" value={this.state.photographer_contact} onChange={this.onChangePhotographerContact} placeholder="Контакт фотографа"/>
                    </Form.Group>
                    <Form.Group controlId="exampleForm.ControlSelect1">
                        <Form.Label>Приоритет</Form.Label>
                        <Form.Control as="select" onChange={this.onChangePriority} value={this.state.priority}>
                            <option value="0">Низкий</option>
                            <option value="1">Средний</option>
                            <option value="2">Высокий</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Ссылка на новый альбом (заполнять, только если нужно обновить альбом)</Form.Label>
                        <Form.Control name="new_album_link" value={this.state.new_album_link} onChange={this.onChangeNewAlbumLink} placeholder="Ссылка на новый альбом"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Ссылка на страницу фотографа</Form.Label>
                        <Form.Control name="photographer_vk_link" value={this.state.photographer_vk_link} onChange={this.onChangePhotographerVkLink} placeholder="Ссылка на страницу фотографа"/>
                    </Form.Group>
                    <Form.Group>
                        <Button onClick={this.editAlbum}>Редактировать</Button>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}

export default withRouter(AlbumEdit);







// WEBPACK FOOTER //
// ./src/components/AlbumEdit.js